/**
 * Maps CMS icon identifiers to Heroicons names for use with UIcon.
 * CMS icon options are defined in cms/src/core/blocks.py ICONS constant.
 */
const iconMap: Record<string, string> = {
  '$info': 'i-heroicons-information-circle',
  '$clock': 'i-heroicons-clock',
  '$first-aid': 'i-heroicons-heart',
  '$law': 'i-heroicons-scale',
  'attach_money': 'i-heroicons-banknotes',
  '$car': 'i-heroicons-truck',
  '$trailer': 'i-heroicons-truck',
  '$reacquisition': 'i-heroicons-arrow-path',
  '$special-plan': 'i-heroicons-clipboard-document-list',
  '$check': 'i-heroicons-check-circle',
  '$phone': 'i-heroicons-phone',
  '$email': 'i-heroicons-envelope',
  '$facebook': 'i-simple-icons-facebook',
};

export function mapIcon(cmsIcon: string | undefined): string {
  if (!cmsIcon) return 'i-heroicons-question-mark-circle';
  return iconMap[cmsIcon] ?? 'i-heroicons-question-mark-circle';
}
